<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const emit = defineEmits(['close'])
const { t } = useI18n()
</script>

<template>
  <div class="sidebar-panel is-generic">
    <div class="subpanel-header">
      <h3 class="no-mb">{{ t('sidebar-message') }}</h3>
      <div class="panel-close" @click="emit('close')">
        <i aria-hidden="true" class="iconify" data-icon="feather:x"></i>
      </div>
    </div>
    <div class="inner" data-simplebar>
      <ul>
        <li>
          <RouterLink
            :to="{ name: 'message-system' }"
            style="display: flex; align-items: center"
          >
            <i
              class="iconify"
              data-icon="feather:bell"
              aria-hidden="true"
              style="margin-right: 2px"
            ></i>
            {{ t('sidebar-message-system') }}
          </RouterLink>
        </li>
        <li>
          <RouterLink
            :to="{ name: 'message-comment' }"
            style="display: flex; align-items: center"
          >
            <i
              class="iconify"
              data-icon="feather:message-square"
              aria-hidden="true"
              style="margin-right: 2px"
            ></i>
            {{ t('sidebar-message-comment') }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
@import '../../scss/abstracts/_variables.scss';
@import '../../scss/layout/_sidebar-panel.scss';
</style>
